import { Context } from '@growthbook/growthbook';
import { environment } from 'environments/environment';

export const context: Context = {
  ...environment.growthbookContext,
};
